module.exports = __webpack_public_path__ + "3fK-R6lR.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 18
// module chunks = 0